<template>
  <div class="row mt-2 px-2">
    <b-carousel
      id="carousel-1"
      class="col-8 p-1 border-radius-10"
      :interval="4000"
      controls
      style="text-shadow: 1px 1px 2px #333;"
    >
      <b-carousel-slide class="border-radius-10" :img-src="`${christmas}`"></b-carousel-slide>
      <b-carousel-slide class="border-radius-10" :img-src="Luckytwin"></b-carousel-slide>
      <b-carousel-slide class="border-radius-10" :img-src="Legend_of_dolly"></b-carousel-slide>
      <b-carousel-slide class="border-radius-10" :img-src="BigEvent"></b-carousel-slide>
      <b-carousel-slide class="border-radius-10" :img-src="Daily_login"></b-carousel-slide>
      <b-carousel-slide class="border-radius-10" :img-src="Lucky_wheel"></b-carousel-slide>
    </b-carousel>
    <div class="col-4">
      <b-img left :src="event" class="secondary-banner p-1 w-100" fluid alt="reset_level"/>
      <b-img left :src="DailyTournamentSmall" class="secondary-banner p-1 w-100" fluid alt="Responsive image"/>
    </div>
  </div>
</template>

<script>
import pic05 from '../assets/banner/big-banner/05.png'
import Daily_login from '../assets/banner/big-banner/Daily_login.png'
import Lucky_wheel from '../assets/banner/big-banner/Lucky_wheel.png'
import BigEvent from '../assets/banner/big-banner/BigEvent.png'
import sPic01 from '../assets/banner/small-banner/01.png'
import sPic02 from '../assets/banner/small-banner/02.png'
import newevent from '../assets/banner/small-banner/newevent.png';
import DailyTournamentSmall from '../assets/banner/small-banner/Daily_tornament_sm.png'
import GameMarket from '../assets/banner/small-banner/game_market.png';
import LegendOfDolly from '../assets/banner/big-banner/Legend_of_dolly.gif';
import christmas from '../assets/banner/big-banner/banner_christmas.gif'
import Luckytwin from '../assets/banner/big-banner/smg_luckytwinswilds_banner_715x360_th.gif';

export default {
  name: 'banner',
  created() {
  },
  data() {
    return {
      event: GameMarket,
      newevent: newevent,
      pic05: pic05,
      sPic01: sPic01,
      sPic02: sPic02,
      sliding: null,
      Daily_login: Daily_login,
      Lucky_wheel: Lucky_wheel,
      BigEvent: BigEvent,
      DailyTournamentSmall: DailyTournamentSmall,
      Legend_of_dolly: LegendOfDolly,
      Luckytwin: Luckytwin,
      christmas,
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.col-4, .col-8 {
  padding: 0;
}
img {
  border-radius: 10px;
}
.border-radius-10 {
  border-radius: 10px;
}
</style>
